import React from "react";
import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import translator from "../utilities/translator";
import { examStatusToString } from "../logic/utilsClinical.js";
import ExamStatusEnum from "../logic/ExamStatusEnum";
import {
	formattedDate,
	formattedDateTime,
	formattedAge,
} from "../utilities/dateFormatter";

function ExamRefListRecord({
	highlightId,
	highlightName,
	exam,
	index,
	isSelected,
	setSelectedExam,
	compactView,
}) {
	const { Option } = Select;

	const token = useSelector((state) => state.session.token);
	const userInfo = useSelector((state) => state.session.userInfo);
	const currentLanguage = useSelector(
		(state) => state.session?.userPreferences?.language
	);
	const userPermissions = useSelector((state) => state.session.userPermissions);
	const [doubleClickCheck, setDoubleClickCheck] = React.useState();

	React.useEffect(() => {
		if (doubleClickCheck) {
			setTimeout(() => {
				setDoubleClickCheck(undefined);
			}, 400);
		}
	}, [doubleClickCheck]);

	const getHighlightedText = (text) => {
		if (highlightId?.length > 0 || highlightName?.length > 0) {
			// Split on highlight term and include term into parts, ignore case
			const parts = text?.toString()?.split(" ");

			return (
				<>
					{" "}
					{parts?.map((part, i) =>
						(highlightId?.length > 0 &&
							part
								.toLowerCase()
								.normalize("NFD")
								.replace(/[\u0300-\u036f]/g, "") ===
								highlightId
									?.toLowerCase()
									.normalize("NFD")
									.replace(/[\u0300-\u036f]/g, "")) ||
						(highlightName?.length > 0 &&
							part
								.toLowerCase()
								.normalize("NFD")
								.replace(/[\u0300-\u036f]/g, "")
								.includes(
									highlightName
										?.toLowerCase()
										.normalize("NFD")
										.replace(/[\u0300-\u036f]/g, "")
								)) ? (
							<mark key={i} className="searchHighLight">
								{part}
							</mark>
						) : (
							<>{part}&nbsp;</>
						)
					)}{" "}
				</>
			);
		}
		return <>{text}</>;
	};

	return (
		<tr
			className="align-center"
			style={{ minHeight: "90px", cursor: "pointer" }}
		>
			{
				<>
					<td
						className="bg-white"
						style={{
							whiteSpace: "nowrap",
							width: "45px",
							borderLeft: isSelected
								? "2px solid green"
								: false
								? "2px solid #A0A0A0"
								: "2px solid transparent",
							borderTop: isSelected
								? "2px solid green"
								: false
								? "2px solid #A0A0A0"
								: "2px solid transparent",
							borderBottom: isSelected
								? "2px solid green"
								: false
								? "2px solid #A0A0A0"
								: "2px solid transparent",
						}}
						onClick={async (e) => {
							e.preventDefault();
							if (setSelectedExam) {
								setSelectedExam(isSelected ? null : exam, e.shiftKey);
							}
						}}
					>
						<div
							className={
								"form-group check-design " + (false ? "check-design-grey" : "")
							}
							style={{ paddingTop: "1.5rem" }}
						>
							<input
								type="checkbox"
								id={`exam-${index}`}
								readOnly={true}
								checked={isSelected || false}
							/>
							<label
								className="big"
								style={{ fontSize: "45px !important" }}
								htmlFor={`exam-${index}`}
							></label>
						</div>
					</td>
					<td
						className="bg-white"
						align="center"
						style={{
							whiteSpace: "nowrap",
							width: "40px",
							fontSize: "45px",
							borderTop: isSelected
								? "2px solid green"
								: false
								? "2px solid #A0A0A0"
								: "2px solid transparent",
							borderBottom: isSelected
								? "2px solid green"
								: false
								? "2px solid #A0A0A0"
								: "2px solid transparent",
						}}
					>
						{exam.status !== ExamStatusEnum.SIGNED && (
							<i
								title={examStatusToString(currentLanguage, exam)}
								className="zmdi zmdi-book-image active"
							></i>
						)}
						{exam.status === ExamStatusEnum.SIGNED && (
							<div
								title={examStatusToString(currentLanguage, exam)}
								className="zmdi-hc-stack zmdi-hc-lg "
							>
								<i className="zmdi zmdi-file zmdi-hc-stack-2x active"></i>
								<i className="zmdi zmdi-check zmdi-hc-stack-1x"></i>
							</div>
						)}
					</td>
					<td
						className="bg-white"
						width="99%"
						style={{
							borderTop: isSelected
								? "2px solid green"
								: false
								? "2px solid #A0A0A0"
								: "2px solid transparent",
							borderBottom: isSelected
								? "2px solid green"
								: false
								? "2px solid #A0A0A0"
								: "2px solid transparent",
						}}
					>
						<div
							style={{ minWidth: "250px" }}
							onClick={async (e) => {
								e.preventDefault();
								if (doubleClickCheck) {
									window.location.href = `/exam-review/${exam.id}`;
								} else {
									setDoubleClickCheck(exam);
									if (setSelectedExam) {
										setSelectedExam(isSelected ? null : exam, e.shiftKey);
									}
								}
							}}
						>
							{compactView && (
								<p
									style={{
										margin: 0,
										color: "#333",
										fontSize: "1em",
										letterSpacing: "0.2px",
									}}
								>
									Eid {getHighlightedText(exam.id)} &nbsp;&nbsp;·&nbsp;&nbsp;
									Rid {getHighlightedText(exam.reportId)}
								</p>
							)}
							{!compactView && (
								<div
									style={{ display: "flex", alignItems: "center", gap: "6px" }}
								>
									<h3
										className="font-sfpro"
										style={{ margin: 0, fontWeight: 600 }}
									>
										{getHighlightedText(exam.patFirstName)}{" "}
										{getHighlightedText(exam.patMiddleName)}{" "}
										{getHighlightedText(exam.patLastName)}
									</h3>
									<span
										style={{
											backgroundColor: "#f6f6f6",
											color: "#555",
											borderRadius: "8px",
											padding: "2px 8px",
											fontSize: "0.8em",
											fontWeight: 500,
										}}
									>
										{formattedAge(exam?.patDob)}
									</span>
								</div>
							)}
							<p
								style={{
									margin: 0,
									display: "flex",
									alignItems: "center",
									gap: "6px",
								}}
							>
								<span style={{ color: "#000", fontWeight: 600 }}>
									{getHighlightedText(exam.tecAreaCode)}
									{" - "}
									{getHighlightedText(exam.productName)}
								</span>
							</p>
							<p
								style={{
									margin: 0,
									display: "flex",
									alignItems: "center",
									gap: "6px",
								}}
							>
								<span style={{ color: "#333", fontSize: "1em" }}>
									PID: {getHighlightedText(exam.patIdent)}
								</span>
								<span style={{ color: "#333", fontSize: "1em" }}>
									DT: {formattedDateTime(exam.planDatetime)}
								</span>
							</p>
						</div>
					</td>
					<td
						className="bg-white a-status dropdesign"
						style={{
							whiteSpace: "nowrap",
							width: "280px",
							borderTop: isSelected
								? "2px solid green"
								: false
								? "2px solid #A0A0A0"
								: "2px solid transparent",
							borderBottom: isSelected
								? "2px solid green"
								: false
								? "2px solid #A0A0A0"
								: "2px solid transparent",
						}}
					>
						<div
							className="d-flex align-items-center"
							style={{
								width: "100%",
								padding: "4px 10px",
							}}
						>
							<p
								className="font-sfpro mb-0"
								style={{
									wordBreak: "break-all",
									width: "100%",
									fontWeight: 700,
									color: "#000",
								}}
							>
								{exam.reportUsrName?.length > 0 ? exam.reportUsrName : "—"}
							</p>
						</div>

						<div
							className="d-flex align-items-center"
							style={{
								width: "100%",
								padding: "4px 10px",
							}}
						>
							<p
								className="font-sfpro mb-0"
								style={{
									wordBreak: "break-all",
									width: "100%",
									fontWeight: 700,
									color: "#000",
									overflow: "hidden",
									textOverflow: "ellipsis",
									whiteSpace: "nowrap",
									display: "block",
								}}
							>
								{getHighlightedText(
									exam.instName?.length > 0 ? exam.instName : "N/A"
								)}
							</p>
						</div>

						<div
							className="d-flex align-items-center"
							style={{
								width: "100%",
								padding: "4px 10px",
							}}
						>
							<p
								className="font-sfpro mb-0"
								style={{
									wordBreak: "break-all",
									width: "100%",
								}}
							>
								{getHighlightedText(
									exam.refEntName?.length > 0 ? exam.refEntName : "N/A"
								)}
							</p>
						</div>
					</td>
					<td
						className="bg-white table-viewsec"
						style={{
							whiteSpace: "nowrap",
							width: "180px",
							borderTop: isSelected
								? "2px solid green"
								: false
								? "2px solid #A0A0A0"
								: "2px solid transparent",
							borderBottom: isSelected
								? "2px solid green"
								: false
								? "2px solid #A0A0A0"
								: "2px solid transparent",
							borderRight: isSelected
								? "2px solid green"
								: false
								? "2px solid #A0A0A0"
								: "2px solid transparent",
						}}
					>
						<div className="exam-custom-icons-row capital">
							<div className="icon-b">
								<i
									className={
										exam.hasImages
											? "zmdi zmdi-image zmdi-hc-2x pr-4 active"
											: "zmdi zmdi-image zmdi-hc-2x pr-4"
									}
									title={translator(currentLanguage, "has_images")}
								></i>
							</div>
							<div className="icon-b" style={{ marginLeft: "1em" }}>
								{exam.reportId > 0 && exam.status === ExamStatusEnum.SIGNED ? (
									<div className="zmdi-hc-stack zmdi-hc-lg ">
										<i className="zmdi zmdi-file zmdi-hc-stack-2x active"></i>
										<i className="zmdi zmdi-check zmdi-hc-stack-1x"></i>
									</div>
								) : (
									<div className="zmdi-hc-stack zmdi-hc-lg " style={{}}>
										<i className="zmdi zmdi-file zmdi-hc-stack-2x"></i>
										<i className="zmdi zmdi-check zmdi-hc-stack-1x"></i>
									</div>
								)}
							</div>
						</div>
					</td>
				</>
			}
		</tr>
	);
}

export default ExamRefListRecord;
